import { useCallback } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import { atomWithGlobalState } from '@highlight/ipc/jotai'

/** Enough to cover every banner kind across a couple of periods. Older keys can't match again. */
const MAX_DISMISSALS = 32

/**
 * Dismissed banner occurrences (PlanBanner.dismissKey). GlobalState so a
 * dismissal survives a restart and holds in every window.
 */
const dismissedPlanBannersAtom = atomWithGlobalState<Array<string>>('sidepanel.dismissedPlanBanners', [])

export const useDismissedPlanBanners = () => useAtomValue(dismissedPlanBannersAtom)

export function useDismissPlanBanner() {
  const set = useSetAtom(dismissedPlanBannersAtom)
  return useCallback(
    (dismissKey: string) =>
      set((current) => (current.includes(dismissKey) ? current : [...current, dismissKey].slice(-MAX_DISMISSALS))),
    [set],
  )
}

/**
 * The period end that was current when the gateway refused a brief for the
 * plan's monthly cap. The client can't count briefs itself, so the refusal is
 * what docks the banner, and the next period retires it.
 */
const briefLimitPeriodEndAtom = atomWithGlobalState<string | null>('sidepanel.briefLimitPeriodEnd', null)

export const useBriefLimitPeriodEnd = () => useAtomValue(briefLimitPeriodEndAtom)

export const useRecordBriefLimit = () => useSetAtom(briefLimitPeriodEndAtom)
